import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/horizontal/email.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23a9038c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23a9038c', __exports__)) {
    console.log('reload')
    api.reload('23a9038c', __exports__)
  }
  
}


export default __exports__